<template>
  <nuxt-link
    :to="{
      name: PageKey.TUTORIAL_INFO,
      params: { id: data.id },
    }"
  >
    <div class="tutorial-other-card" :class="{ active: active }">
      <div class="cover w-[142px] h-[80px]">
        <div class="w-full h-full absolute top-0 left-0">
          <Resource
            :src="data.cover_url"
            class="w-full h-full object-cover rounded-[8px]"
            :transform-resource="transformImage"
          />
          <div class="time">
            {{ formatDuration(data?.video_duration * 1000) }}
          </div>
        </div>
      </div>
      <div class="flex flex-col justify-between w-[182px]">
        <div class="name">
          {{ data.name }}
        </div>
      </div>
    </div>
  </nuxt-link>
</template>

<script setup lang="ts">
import { PageKey } from '~/constants/page';
import { useTime } from '~/hooks/useTime';
import { transformImage } from '~/utils/';

const { formatDuration } = useTime();

const props = defineProps<{
  data: any;
  active: boolean;
}>();
</script>

<style lang="scss" scoped>
.tutorial-other-card {
  @apply flex gap-[8px];
  padding: 8px;
  border-radius: 12px;

  &.active,
  &:hover {
    background-color: var(--purple-1);

    .name {
      color: var(--purple-6);
    }
  }

  .cover {
    @apply relative;
    &::before {
      content: ' ';
      display: block;
      padding-top: 56.3%;
    }
    .time {
      @apply absolute bottom-[6px] right-[6px] rounded-[12px] text-[12px] p-[4px_7px];
      background: rgba(0, 0, 0, 0.4);
      color: white;
    }
  }
  .name {
    @apply text-14 text-font-1 line-clamp-2 font-semibold;
  }
}
</style>
